<template>
  <v-container fluid>
    <v-row dense>
      <v-col cols="12" sm="10">
        <px-autocomplete-mensagem-personalizada
          class="rounded-tag-small"
          dense
          v-model="mensagemPersonalizada"
          :error="$v.mensagemPersonalizada.$error"
          @blur="$v.mensagemPersonalizada.$touch()"/>
      </v-col>
      <v-col cols="12" sm="2" align-self="center">
        <v-btn color="primary"
               small
               class="normal-btn-text rounded-tag-small elevation-0"
               @click="onClickAdd">
          <v-icon small>mdi-plus</v-icon>
          Adicionar
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" v-if="checkMessages">
        <v-card outlined class="rounded-card">
          <px-mensagens-personalizadas-list
              show-actions
              :messages="finalizacao.mensagensPersonalizadas"
              :loading="loading"
              @remove="onRemove"/>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import validationMixin from '@/mixins/validation-mixin';
import { required } from 'vuelidate/lib/validators';
import MessageService from '@/api/message-service';

export default {
  mixins: [validationMixin],
  props: {
    finalizacao: {
      type: Object,
      required: true,
    },
  },
  computed: {
    checkMessages() {
      return this.finalizacao.mensagensPersonalizadas
        && this.finalizacao.mensagensPersonalizadas.length
        && this.finalizacao.mensagensPersonalizadas.length > 0;
    },
  },
  data() {
    return {
      loading: false,
      mensagemPersonalizada: null,
    };
  },
  methods: {
    checkAlreadyAdded(id) {
      return this.finalizacao.mensagensPersonalizadas.find(message => message.id === id);
    },
    onClickAdd() {
      if (this.validateForm()) {
        return;
      }
      if (this.checkAlreadyAdded(this.mensagemPersonalizada.id)) {
        this.$toast('Mensagem já adicionada', { color: 'error' });
        this.mensagemPersonalizada = null;
        return;
      }
      this.finalizacao.mensagensPersonalizadas.push(this.mensagemPersonalizada);
      this.mensagemPersonalizada = null;
    },
    onRemove(item) {
      this.$emit('remove', item);
    },
    getMessagesPadrao() {
      this.loading = true;
      const params = {
        query: 'padrao is true',
      };
      MessageService.getMessages(params)
        .then((response) => {
          this.finalizacao.mensagensPersonalizadas = response.data.content;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    if (this.finalizacao.mensagensPersonalizadas.length === 0) {
      this.getMessagesPadrao();
    }
  },
  validations: {
    mensagemPersonalizada: {
      required,
    },
  },
};
</script>
